var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('core-toolbar'),(_vm.base_info_finish)?_c('core-drawer',{attrs:{"items":_vm.items}}):_vm._e(),_c('core-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }